import { createReduxModule } from 'hooks-for-redux'
import { StatusCodes } from "http-status-codes";
import { getAutocompleteResults } from '../api/searchApi'
import { IAutocompleteResponse } from '../api/searchApi.types'

const initialState: IAutocompleteResponse = {
    hits: []
} 

export const [useAutocomplete, { setAutocompleteResults }, autocompleteStore] = createReduxModule(
    'autocomplete', initialState, {
    // Reducers
    setAutocompleteResults: (
        autocompleteResults: IAutocompleteResponse,
        partialAutocompleteResults: IAutocompleteResponse) =>
        ({ ...autocompleteResults, ...partialAutocompleteResults }),
    }
)

export const updateAutocomplete = async (searchTerm: string, size: number = 5) => {
    const result = await getAutocompleteResults(searchTerm, size);
    if (result?.status !== StatusCodes.OK) return result?.status;

    setAutocompleteResults(result.data);

    return StatusCodes.OK;
}